<template>
  <v-dialog max-width="500px" v-model="showDialog" persitent scrollable>
    <v-card>
      <v-toolbar dark color="secondary">
        <v-card-title class="headline"> Unfinished Units </v-card-title>
        <v-spacer />
        <button
          type="button"
          class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm"
          @click="showDialog = false"
        >
          <i class="fal fa-times" />
        </button>
      </v-toolbar>
      <v-card-text>
        <ul class="list-unstyled pl-1">
          <template v-for="(unit, index) in units">
            <li :key="index" class="border-bottom">
              <div class="row" @click="goToUnit(unit.id)">
                <div class="col-md-3">
                  <img
                    :src="unit.thumbnail"
                    alt="thumbnail"
                    style="width: 100%"
                  />
                </div>
                <div class="col-md-9 pt-4 position-relative">
                  <h6>{{ unit.name }}</h6>
                  <p class="kt-font-info mb-1">{{ unit.module.name }}</p>
                  <p class="mb-0">
                    <i class="far fa-clock" />
                    {{ unit.video_duration }}
                  </p>
                  <i
                    v-show="unit.checked"
                    class="fa fa-check position-absolute unitChecked kt-font-primary"
                  />
                </div>
              </div>
            </li>
          </template>
        </ul>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UnfinishedContentsDialog',
  computed: {
    showDialog: {
      get() {
        return this.$store.state.assignedAndSharedContents.showDialog;
      },
      set(state) {
        this.$store.dispatch(
          'assignedAndSharedContents/setShowDialogState',
          state
        );
      },
    },
    units() {
      return this.$store.state.assignedAndSharedContents.units;
    },
  },
  methods: {
    goToUnit(id) {
      const route = this.$router.resolve({ name: 'UnitPage', params: { id } });

      window.open(route.href, '_blank');
    },
  },
};
</script>

<style scoped></style>
